import { find, propEq } from 'ramda';
import { FORM_NAMES } from '../../constants/forms';
import CONSTANTS from '../../constants/externalReferences';
import { createDateFormat } from '../../utils/common';

const externalReferenceProp = 'ExternalReference';

export const getAdditionalProperties = (
  additionalProp = [],
  externalReference,
  key = externalReferenceProp,
) => find(propEq(key, externalReference))(additionalProp);

export const isUpdateCred = (name) =>
  name === FORM_NAMES.EMAILADDRESS || name === FORM_NAMES.PASSWORD;

const getEmailPasswordPayload = (name, formikValues) => {
  const isEmailAddress = name === FORM_NAMES.EMAILADDRESS;
  return {
    CurrentPassword: formikValues.currentPassword,
    NewLogin: isEmailAddress ? formikValues.confirmNewEmailAddress : null,
    NewPassword: isEmailAddress ? null : formikValues.newPassword,
  };
};

export const getUpdateSubscriberPayload = (
  name,
  subscriberDetails,
  formikValues = {},
  isUpdateCred = false,
  localDateFormat,
) => {
  if (isUpdateCred) {
    // update Credential Api Payload goes here...
    return getEmailPasswordPayload(name, formikValues);
  }
  if (name === FORM_NAMES.BIRTHDAY) {
    const dateFormat = createDateFormat(localDateFormat);
    const parsedDateformat = dateFormat.parse(formikValues.BirthDate);
    const birthDateTimestamp =
      dateFormat.formatForSubscriberAPI(parsedDateformat);
    return {
      Subscriber: {
        ...subscriberDetails,
        BirthDate: birthDateTimestamp,
      },
    };
  }
  if (name === FORM_NAMES.RECEIVEDLATESTNEWS) {
    const getSubscriberDetailsProps = [
      {
        ExternalReference: CONSTANTS.CONSENT_CONTACT,
        Values: [formikValues.receivedLatestNews ? 1 : 0],
      },
    ];
    return {
      Subscriber: {
        ...subscriberDetails,
        AdditionalProperties: getSubscriberDetailsProps,
      },
    };
  }
  if (name === FORM_NAMES.COUNTRYOFRESIDENCE) {
    const getSubscriberDetailsProps = [
      {
        ExternalReference: CONSTANTS.MARKETING_COUNTRY,
        Values: [formikValues.country],
      },
    ];
    return {
      Subscriber: {
        ...subscriberDetails,
        AdditionalProperties: getSubscriberDetailsProps,
      },
    };
  }
  const title =
    formikValues.Title === 'Select' ? undefined : formikValues.Title;
  return {
    Subscriber: { ...subscriberDetails, ...formikValues, Title: title },
  };
};
